//eslint-disable-next-line
import axios from "axios";
const base = process.env.VUE_APP_API_BASEURL;


export const state = {
    sop_groups:null,
    selected_sop_group: null,
    sops:null,
    sop_data: null,
    all_attachments:null,
    distribution_clients: null,
    distribution_sop: null,
    sop_stats: null,
    context_menu_id: -1,
    client_sop_data: null,
    notifications: null,
};


export const mutations = {
    setSopGroups(state, payload){
        state.sop_groups = payload;
    },
    setSops(state, payload){
        state.sops = payload;
    },
    setSopData(state, payload){
        state.sop_data = payload;
    },
    setSelectedSopGroup(state, payload){
        state.selected_sop_group = payload;
    },
    clearStore(state, payload){
        state.sop_data = payload;
    },
    setAllAttachments(state, payload){
        state.all_attachments = payload;
    },
    setRightClickMenuID(state, payload){
        state.context_menu_id = payload;
    },
    setDistributionClients(state, payload){
        state.distribution_clients = payload;
    },
    setDistributionSop(state, payload){
        state.distribution_sop = payload;
    },
    setSopStats(state, payload){
        state.sop_stats = payload;
    },
    setClientSopData(state, payload){
        state.client_sop_data = payload;
    },
    setNotifications(state, payload){
        state.notifications = payload;
    },
    resetStore(state, payload){
        state.sop_groups = payload;
        state.selected_sop_group = payload;
        state.sops = payload;
        state.sop_data = payload;
        state.all_attachments = payload;
        state.context_menu_id = -1;
        state.distribution_clients = payload;
        state.distribution_sop = payload;
        state.sop_stats = payload;
        state.client_sop_data = payload;
        state.notifications = payload;
    }
};


export const actions = {
    //* id of the document item that was right clicked
    setContextMenuID({commit}, id){
        return new Promise((resolve)=>{
            commit('setRightClickMenuID', id);
            resolve();
        });
    },
    selectSopGroup({commit}, sop_group){
        return new Promise((resolve)=>{
            commit('setSelectedSopGroup', sop_group);
            resolve();
        });
    },

    loadNotifications({commit}){
        return new Promise((resolve, reject)=>{
            window.axios.get('api/ccbadmin/notifications/')
            .then((response)=>{
                commit('setNotifications', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },

    //setSelectedGroup
    loadSopGroups({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/sopgroups/')
            .then((response)=>{
                commit('setSopGroups', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    //setSelectedGroup
    loadSops({commit}, id){
        return new Promise((resolve, reject)=>{
            commit('setSops', null);
            axios.get( base + 'api/ccbdocadmin/sopgroup/' + id)
            .then((response)=>{
                commit('setSops', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSopData({commit}, id){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/soptype/' + id)
            .then((response)=>{
                commit('setSopData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },

    loadSopForDistribution({commit}, id){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/soptype/' + id)
            .then((response)=>{
                commit('setDistributionSop', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },

    loadDistributionClients({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/distributeclients/')
            .then((response)=>{
                commit('setDistributionClients', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },

    /*eslint-disable-next-line */
    distributeSop({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/distributesop', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },


    /*eslint-disable-next-line */
    saveSopGroup({commit}, params){//* "id": -1 -- "parent_id": 0 -- "name": "Test Group"
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/savesopgroup', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    
    /*eslint-disable-next-line */
    deleteSopGroup({commit}, params){//* 'id': 1
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/deletesopgroup', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    saveSopAttachment({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/savesopattachment', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    deleteSopAttachment({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/deletesopattachment', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    duplicateSopAttachment({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/duplicatesopattachment', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    saveSopType({commit}, params){//*  "id": -1, | "sop_group_id": 2, | "name": "Test Type", | "sop_code": "SOP-TYPE-002"
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/savesoptype', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    deleteSopType({}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/deletesoptype', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    saveSopRevision({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/savesoprevision', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    /*eslint-disable-next-line */
    previewSop({commit}, params){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/previewsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    getCachedSopPreview({commit}, params){
        /*eslint-disable-next-line */
        return new Promise((resolve, reject) => {
            axios.get( base + 'api/ccbdocadmin/soppreview/' + params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    publishSop({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/publishsop', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },


    getAllAttachments({commit}){
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/sopattachments/')
            .then((response)=>{
                commit('setAllAttachments', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },


    clearSopStore({commit}){
        return new Promise((resolve) => {
            commit('clearStore', null);
            resolve();
        })
    },

    loadSopStats({commit}, params){/* params.client_id, params.step_id */
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/sopstats/' + params.id )
            .then((response)=>{
                commit('setSopStats', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    loadClientSop({commit}, params){/* params.client_id, params.step_id */
        return new Promise((resolve, reject)=>{
            axios.get( base + 'api/ccbdocadmin/clientsop/'+params.type_id+'/'+params.client_id)
            .then((response)=>{
                commit('setClientSopData', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },

    
    /*eslint-disable-next-line */
    saveClientSopRevision({commit}, params){
        return new Promise((resolve, reject) => {
            axios.post( base + 'api/ccbdocadmin/saveclientsoprevision', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    getPreviewB64({}, revision_id){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.get('api/ccbdocadmin/b64preview/' + revision_id)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },
};
